enum ElementId {
  BackgroundOverlay = "BackgroundOverlay",
  BottomDrawerTitleRow = "BottomDrawerTitleRow",
  CampaignFundingTierManageNftsModal = "CampaignFundingTierManageNftsModal",
  CampaignTabs = "CampaignTabs",
  CollectorSurveyModalBanner = "CollectorSurveyModalBanner",
  CollectorSurveyModalRoutes = "CollectorSurveyModalRoutes",
  CreatorSurveyModalBanner = "CreatorSurveyModalBanner",
  CreatorSurveyModalRoutes = "CreatorSurveyModalRoutes",
  FundingTiersInputButton = "FundingTiersInputButton",
  ListNftModal = "ListNftModal",
  ManageSeriesPiecesModal = "ManageSeriesPiecesModal",
}

export default ElementId;
